import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/clientes")({
  component: Page,
});

function Page() {
  return <Outlet />;
}
